import React, { useState, useEffect } from 'react';
import { Radio } from '@material-ui/core';
import { UncheckedRadio, CheckedRadio } from './FilterRadios';
import styles from './filters-dialog.module.scss';

const FiltersDialog = (props): JSX.Element => {
  const {
    timeline, filters, filterResults, selectedFiltersObject, onToggleDialog, showDialog,
  } = props;
  const {
    filtersTrigger, filtersPanel, filtersHeader, closeFiltersDialog, filtersFooter, filtersContent, noFiltersButton,
    showResultsButton, filterSectionTtl, filterRadioItem,
  } = styles;

  const [selectedFilters, setSelectedFilters] = useState({
    timeline: null,
    filter: null,
  });

  /**
     * Toggling filter dialog mode
     * @param value - sets the dialog open or close
     * @param triggerFiltering - is true when SHOW RESULTS button pressed
     */
  const triggerDialog = (value: boolean, triggerFiltering?: boolean) => {
    if (triggerFiltering) {
      filterResults(selectedFilters);
    }
    onToggleDialog(value);
  };

  /**
     * Event fired when radio button checked
     * @param group - group name to be updated
     * @param value - new filter value
     */
  const onRadioChecked = (group, value) => {
    const cloned = { ...selectedFilters };
    cloned[group] = value;
    setSelectedFilters(cloned);
  };

  /**
     * Fired when No Filters button is pressed to reset
     * all selected filters
     */
  const resetFilters = () => {
    setSelectedFilters({
      timeline: null,
      filter: null,
    });
  };

  const noFiltersSelected = () => !selectedFilters.filter && !selectedFilters.timeline;

  /**
   * Initiating filters preset once dialog opens
   */
  useEffect(() => {
    if (showDialog) {
      const cloned = { ...selectedFiltersObject };
      setSelectedFilters(cloned);
    }
  }, [showDialog]);

  /**
     * Generating group of filters according to relevant data array
     * @param title - Group title
     * @param group - group name
     * @param listData - Array of group items
     */
  const generateGroup = (title: string, group: string, listData: string[]) => listData.map((item) => (
            <label key={item} className={filterRadioItem} htmlFor={item}>
                <span>{item}</span>
                <Radio
                    icon={UncheckedRadio()}
                    checkedIcon={CheckedRadio()}
                    id={item}
                    value={item}
                    color="default"
                    name={`radio-${group}-buttons`}
                    onChange={() => onRadioChecked(group, item)}
                    checked={selectedFilters[group] === item}
                    inputProps={{ 'aria-label': item }}
                />
            </label>
  ));

  return (
        <>
            <button className={filtersTrigger} onClick={() => triggerDialog(true)}>More Filters</button>
            {showDialog && (
                <section className={filtersPanel}>
                    <div className={filtersHeader}>
                        <span>More Filters</span>
                        <button className={closeFiltersDialog} onClick={() => triggerDialog(false)}>
                            <i className="ic icon-cross"/>
                        </button>
                    </div>
                    <div className={filtersContent}>
                        { timeline ?
                          <div>
                            <span className={filterSectionTtl}>Timeline</span>
                            {generateGroup('Timeline', 'timeline', timeline)}
                        </div>
                          : null
                        }
                        <div>
                            <span className={filterSectionTtl}>Filters</span>
                            {generateGroup('Filters', 'filter', filters)}
                        </div>
                    </div>
                    <div className={filtersFooter}>
                        <button disabled={noFiltersSelected()} className={noFiltersButton} onClick={resetFilters}>
                            No filters
                        </button>
                        <button className={showResultsButton}
                                onClick={() => { triggerDialog(false, true); }}>
                            SHOW RESULTS
                        </button>
                    </div>
                </section>
            )}
        </>);
};

export default FiltersDialog;
